export const hypercholesterolemiaInformation = "Familial hypercholesterolemia (FH) is a genetic condition that causes high cholesterol beginning in childhood. One in every 250 people in the United States has familial hypercholesterolemia. Most high cholesterol is not due to familial hypercholesterolemia.";

export const smokingPacks = [
  {
    text: "½",
    value: 0.5,
  },
  {
    text: "1",
    value: 1,
  },
  {
    text: "2",
    value: 2,
  },
  {
    text: "3",
    value: 3,
  },
  {
    text: "4",
    value: 4,
  },
  {
    text: "5",
    value: 5,
  },
];

export const emailViabilityError = "The email address is already used by another user account.";

export const clientRole = "Client";
export const clientUserRole = "ClientUser";
export const clientProviderRole = "ClientProvider";
export const adminRole = "Admin";

export const emptyOptionValue = "0";

// Features
export const curativeClient = "curative-client";
export const wholeHeartClient = "wholeheart-client";
export const healthQuotientClient = "healthquotient-client";
export const dataFeedExportEnable = "data-feed-export-enable";
export const diabeticRiskAssessment = "diabetic-risk-assessment";
export const alternateWorkflowOne = "alternate-workflow-one";
export const employerTagging = "employer-tagging";
export const apobCondensedReports = "apob-condensed-reports";
export const ldlpOrders = "ldlp-orders";
export const homaIRAssessment = 'homa-ir-assessment';
export const advancedCra = "advanced-cra";
export const reportVisibility = "report-visibility";
export const defaultOrderType = "default-order-type";
export const defaultLabworkType = "default-labwork-type";
export const showPatientIdOnly = "show-patient-id-only";
export const calculateFib4 = "calculate-fib-4";
